export const doSelectCookies = {
  XSRF_COOKIE_NAME: 'doselectcsrf',
  XSRF_HEADER_NAME: 'X-CSRFToken',
};

export const DEFAULT_MAX_LIMIT = 5;
export const DEFAULT_MULTIPLIER_PAGINATION = 10;
export const INPUT_MIN_LENGTH = 3;
export const INPUT_MAX_LENGTH = 75;

export const LENGTH_VALIDATION_MESSAGE = 'must be between 3 and 75 characters.';

export const DELAY_SECONDS = 0.5;

export const DEFAULT_SSO_USER_ID_FOR_CODE_EDITOR = 12345;
export const DEFAULT_SSO_USER_NAME_FOR_CODE_EDITOR = 'ssoUser';
export const NAV_TAB_TYPES = {
  default: 'default',
  green: 'green',
};
